function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'peachycotta': 'rgb(224, 164, 134)','blush': 'rgb(230, 195, 203)','mint': 'rgb(185, 190, 167)','midnight': 'rgb(40, 46, 79)','oatmeal': 'rgb(189, 158, 122)','mustard': 'rgb(186, 134, 27)','sand': 'rgb(224, 224, 209)','terra': 'rgb(143, 89, 66)','rust': 'rgb(186, 86, 53)','dark': 'rgb(71, 34, 24)','light': 'rgb(213, 140, 76)','forest-green': 'rgb(41, 74, 35)','blue': 'rgb(36, 62, 140)',};

    this.images = {'speckled-mint': 'url("//www.lbedesign.com/cdn/shop/files/SpeckledMintSwatch_68x.png?v=11703574050556506918")','cream-speckle': 'url("//www.lbedesign.com/cdn/shop/files/CreamSpeckleSwatch_68x.png?v=15493840245662179999")','darkened-teak': 'url("//www.lbedesign.com/cdn/shop/files/darkenedteak_68x.png?v=3263430701976941505")','natural-teak': 'url("//www.lbedesign.com/cdn/shop/files/natural-teak_68x.png?v=15805858801923206562")',};

    this.triggers = ['color','colour','couleur','farbe','cor','darkenedteak','naturalteak',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
